import { Box, Typography } from "@mui/material";
import "./_style.scss";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import {
  childcareLeaveTableHead,
  fakeTableList,
  salaryTableHead,
  schema,
} from "./parts";
import { useContext, useEffect, useState, useRef } from "react";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkTable from "../../components/atoms/TkTable";
import { useLocation, useNavigate } from "react-router-dom";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  ApplicationStatus,
  FormClassRetire,
  FormKbn,
  HalfYearExtensionReason,
  PapaMamaPlus,
  Prefectures,
  RetireFlowReason,
  RetireReason,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import { httpAPI_STA003 } from "./api/request";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import _ from "lodash";
import { changeZipcodeFormat } from "../../utils/useTools";

/**
 * SCRW060005_退職情報　登録（登録内容の確認）
 * @return SCRW060005_退職情報　登録（登録内容の確認）
 */
const SCRW060005 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);

  // ユーザタイプ
  const userType = state.authInfo?.userType;
  // ユーザタイプが機構か
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;

  const [stateInfoList, setStateInfoList] = useState<any>([]);

  // 育休状況
  const [childcareLeaveBodyList, setChildcareLeaveBodyList] = useState<any>();

  // 本俸月額登録
  const [salaryTableList, setSalaryTableList] = useState<any>([]);

  // 法人申請区分
  const [corpApplyKbn, setCorpApplyKbn] = useState<"1" | "other" | undefined>();
  // 法人申請区分
  const [latestApplyStatus, setLatestApplyStatus] = useState<string>();
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const handleInit = async () => {
    let resArr = stateFakeTableList.current;

    try {
      const res = await httpAPI_STA003({
        contractorNo: businessState.common?.contractorNo,
        staffNo: businessState.job_32?.staffNo,
        applyId: location.state?.applyId ?? businessState.job_32?.applyId,
      });

      if (res.resultCd === "I0000") {
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;
          targetObj && (targetObj.setDefaultValue = res[i as keyof typeof res]);
          targetObj && (targetObj.text = res[i as keyof typeof res]);
        }
        // 法人申請区分
        setCorpApplyKbn(res.corpApplyKbn as keyof typeof corpApplyKbn);
        // 最新申請状態
        setLatestApplyStatus(res.latestApplyStatus);
        // 退職理由
        const nRetireReasonCdText = TkGetCode(
          RetireReason,
          res.nRetireReasonCd
        );
        // 退職者名（新）
        const staffNameKanjiInput = resArr.find(
          (item) => item.keyword === "staffNameKanji"
        )!;
        // 退職者名カナ（新）
        const staffNameKanaInput = resArr.find(
          (item) => item.keyword === "staffNameKana"
        )!;
        // 退職者名漢字
        const bNameKanjiInput = resArr.find(
          (item) => item.keyword === "bNameKanji"
        )!;
        // 退職者名カナ
        const bNameKanaInput = resArr.find(
          (item) => item.keyword === "bNameKana"
        )!;

        if (res?.bNameKanji) {
          staffNameKanjiInput.text = res?.staffNameKanji;
          bNameKanjiInput.text = res?.bNameKanji;
        } else {
          staffNameKanjiInput.showLine = false;
          bNameKanjiInput.text = res?.staffNameKanji;
        }

        if (res?.bNameKana) {
          staffNameKanaInput.text = res?.staffNameKana;
          bNameKanaInput.text = res?.bNameKana;
        } else {
          staffNameKanaInput.showLine = false;
          bNameKanaInput.text = res?.staffNameKana;
        }
        let nRetireReasonCd = resArr.find(
          (item) => item.keyword === "nRetireReasonCd"
        )!;
        nRetireReasonCd.text = nRetireReasonCdText;

        resArr.find((item) => item.keyword === "retireProcedureReason")!.text =
          TkGetCode(RetireFlowReason, res.retireProcedureReason);

        let zipcode = resArr.find((item) => item.keyword === "zipcode")!;
        zipcode.text = changeZipcodeFormat(res.zipcode);

        // 退職者住所
        let address = resArr.find((item) => item.keyword === "address")!;
        if (
          res?.prefectureCd !== "" &&
          res?.prefectureCd !== undefined &&
          res?.addressCity !== "" &&
          res?.addressCity !== undefined &&
          res?.addressOthers !== "" &&
          res?.addressOthers !== undefined
        ) {
          address.text = `${TkGetCode(Prefectures, res?.prefectureCd)}${
            res?.addressCity
          }${res?.addressOthers}`;
        }
        // 現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である
        let continueTransferApplicable1Flg = resArr.find(
          (item) => item.keyword === "continueTransferApplicable1Flg"
        )!;
        continueTransferApplicable1Flg.text =
          !res?.continueTransferApplicable1Flg ||
          res?.continueTransferApplicable1Flg === "" ||
          res?.continueTransferApplicable1Flg === "0"
            ? ""
            : "該当";
        // 現在の共済契約者の退職日の翌日が、転職先の共済契約者への就職日である
        let continueTransferApplicable2Flg = resArr.find(
          (item) => item.keyword === "continueTransferApplicable2Flg"
        )!;
        continueTransferApplicable2Flg.text =
          !res?.continueTransferApplicable2Flg ||
          res?.continueTransferApplicable2Flg === "" ||
          res?.continueTransferApplicable2Flg === "0"
            ? ""
            : "該当";

        // ならない月
        let notToBeMonth = resArr.find(
          (item) => item.keyword === "notToBeMonth"
        )!;
        const notToBeMonthList: string[] = [];
        if (res?.apr && res?.apr !== "" && res?.apr !== "0") {
          notToBeMonthList.push("4月");
        }
        if (res?.may && res?.may !== "" && res?.may !== "0") {
          notToBeMonthList.push("5月");
        }
        if (res?.jun && res?.jun !== "" && res?.jun !== "0") {
          notToBeMonthList.push("6月");
        }
        if (res?.jul && res?.jul !== "" && res?.jul !== "0") {
          notToBeMonthList.push("7月");
        }
        if (res?.aug && res?.aug !== "" && res?.aug !== "0") {
          notToBeMonthList.push("8月");
        }
        if (res?.sep && res?.sep !== "" && res?.sep !== "0") {
          notToBeMonthList.push("9月");
        }
        if (res?.oct && res?.oct !== "" && res?.oct !== "0") {
          notToBeMonthList.push("10月");
        }
        if (res?.nov && res?.nov !== "" && res?.nov !== "0") {
          notToBeMonthList.push("11月");
        }
        if (res?.dec && res?.dec !== "" && res?.dec !== "0") {
          notToBeMonthList.push("12月");
        }
        if (res?.jan && res?.jan !== "" && res?.jan !== "0") {
          notToBeMonthList.push("1月");
        }
        if (res?.feb && res?.feb !== "" && res?.feb !== "0") {
          notToBeMonthList.push("2月");
        }
        if (res?.mar && res?.mar !== "" && res?.mar !== "0") {
          notToBeMonthList.push("3月");
        }
        notToBeMonth.text = notToBeMonthList.join("、");
        // 退職月の出勤日数
        let retireWorkingDayNum = resArr.find(
          (item) => item.keyword === "retireWorkingDayNum"
        )!;
        res.workingDayNum &&
          (retireWorkingDayNum.text = (res.workingDayNum ?? "") + "日");
        // 共済契約者番号
        let contractorNo = resArr.find(
          (item) => item.keyword === "aContractorNo"
        )!;
        contractorNo.text = res?.aContractorNo;
        // 共済契約者氏名
        let contractorName = resArr.find(
          (item) => item.keyword === "contractorName"
        )!;
        contractorName.text = res?.aCorpName;
        // 賃金台帳(ファイルがあれば)
        const wagesFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["退職書類"] &&
            item.formClass === FormClassRetire["賃金台帳"]
        );

        if (wagesFile) {
          let wages = resArr.find((item) => item.keyword === "wages")!;
          wages.base64filedata = wagesFile.fileBase64;
          wages.dataname = wagesFile.formName;

          wages.showLine = true;
        }

        // 雇用契約書(ファイルがあれば)
        const contractEmploymentFile = res.formList?.find(
          (item) =>
            item.formKbn === FormKbn["退職書類"] &&
            item.formClass === FormClassRetire["雇用契約書"]
        );

        if (contractEmploymentFile) {
          let contractEmployment = resArr.find(
            (item) => item.keyword === "contractEmployment"
          )!;

          contractEmployment.dataname = contractEmploymentFile.formName;
          contractEmployment.base64filedata = contractEmploymentFile.fileBase64;

          contractEmployment.showLine = true;
        }

        // 育休状況
        const bodyListChildcareLeave = res?.childcareLeaveList?.map(
          (item: any) => [
            {
              children: item.childcareLeaveSerialNo,
            },
            {
              children: item.birthday,
              align: "center",
            },
            {
              children: item.startDate,
              align: "center",
            },
            {
              children: item.endDate,
              align: "center",
            },
            {
              children: TkGetCode(PapaMamaPlus, item.papaMamaFlg),
              align: "center",
            },
            {
              children: TkGetCode(
                HalfYearExtensionReason,
                item.halfyearExtensionReason
              ),
            },
            {
              children: item.papaChildcareLeaveFlg === "1" ? "有" : "無",
              align: "center",
            },
          ]
        );
        setChildcareLeaveBodyList(bodyListChildcareLeave);

        // 本俸月額登録
        const salaryList = res.sixMonthsSalaryBeforeApplyList?.map(
          (item: any) => [
            {
              children: `${
                item.yearMonth ? item.yearMonth.toString().slice(0, 4) : ""
              }/${item.yearMonth ? item.yearMonth.toString().slice(4, 6) : ""}`,
              align: "center",
            },
            {
              children: `${item.salaryTableAmt.toLocaleString()}円`,
              align: "right",
            },
            {
              children: `${item.salaryAdjustmentAmt.toLocaleString()}円`,
              align: "right",
            },
          ]
        );
        setSalaryTableList(salaryList);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      console.log(error);
      navigate("/error");
    }

    setStateInfoList([...resArr]);
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box data-testid="SCRW060005PageForTest" className="SCRW060005">
      <TkKikoStepper
        applicationStatus={latestApplyStatus as keyof typeof ApplicationStatus}
        applicationFlowType={"TYPE4"}
        businessType={"JOB-33"}
        corporateApplicationClassification={corpApplyKbn}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW060005_01}</TkInfoManual>
      {isUserTypeKiko && (
        <TkContractorAndNumberLine
          name="契約者(法人)名"
          no={
            (businessState.common?.contractorNo ?? "") +
            ":" +
            (businessState.common?.contractorName ?? "")
          }
        />
      )}
      <TkFakeTable
        list={stateInfoList}
        ruleSchema={schema}
        showButton={false}
      />
      <Typography className="tableTitle">育休状況</Typography>
      <TkTable
        headList={childcareLeaveTableHead}
        bodyList={childcareLeaveBodyList}
      />
      <Typography className="tableTitle">本俸月額登録</Typography>
      <TkTable headList={salaryTableHead} bodyList={salaryTableList} />
      <Box className="button">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRW060005;
